import Ax from './axios';
import CachedRequest from './cacheRequest';

const HOST = 'https://www.colafund.cn';
// const HOST = 'http://172.20.10.6:8080';

export const cachedRequest = new CachedRequest();
export const processApi = (api) => {
  if (!api) throw new Error('需要参数：api');
  if (api.toLowerCase().startsWith('http')) return api;
  return `${HOST}${api[0] === '/' ? api : `/${api}`}`;
};
const base = (method, api, { mockData, mockDelay, dataTransform, requestTransform, cache } = {}) => {
  if (mockData) {
    return () =>
      new Promise((resolve) => {
        setTimeout(() => {
          resolve(mockData);
        }, mockDelay);
      });
  }
  const client = cache ? cachedRequest : Ax;
  return (model) =>
    client[method](processApi(api), {
      ...requestTransform(model),
    }).then((res) => dataTransform(res));
};

export const easyPost = (
  api,
  { mockData, mockDelay = 300, dataTransform = (p) => p, requestTransform = (p) => p, cache = false } = {},
) =>
  base('post', api, {
    mockData,
    mockDelay,
    dataTransform,
    requestTransform,
    cache,
  });

export const easyGet = (
  api,
  { mockData, mockDelay = 300, dataTransform = (p) => p, requestTransform = (p) => p, cache = false } = {},
) =>
  base('get', api, {
    mockData,
    mockDelay,
    dataTransform,
    requestTransform,
    cache,
  });
